import { Button, Card, CardBody, Col, Row, Spinner, Table } from "reactstrap";
import { LuDownload, LuUsers, LuZap } from "react-icons/lu";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import sidebar from "../../utils/sidebar";
import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { get } from "../../../../utils/helpers/api";
import { Link } from "react-router-dom";
import { printPaymentStatus } from "../../utils/helpers";
import "./styles.css";
import ActiveSubscriptionCard from "../../components/Cards/ActiveSubscription";

function BillingPage() {
  const { t } = useTranslation();
  const [ loading, setLoading ] = useState(false);
  const [ activeSubscription, setActiveSubscription ] = useState(null);
  const [ invoiceHistories, setInvoiceHistories ] = useState(null);
  const [ companyData, setCompanyData ] = useState(null);

  const getBillingData = async () => {
    setLoading(true);
    const data = await get('/settings/billing');
    if(data?.success) {
      setActiveSubscription(data.active_subscription);
      setInvoiceHistories(data.invoice_histories?.data);
      setCompanyData(data.company);
    }
    setLoading(false);
  }

  useEffect(() => {
    getBillingData();
  }, []);

  return (
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader title={t('billing.title')} />

        {loading ?
          <Spinner color="primary" className="d-block mx-auto my-4" />
        :
          !activeSubscription && !invoiceHistories?.length ?
            <div className="subheader-page-content scrollable">
              <div className="text-center">
                <img
                  src={require('../../../../assets/images/icons/empty-folder.png')}
                  alt={t('billing.noActiveSubscription')}
                  width={150}
                />
                <p>
                  {t('billing.noActiveSubscriptionMessage')}
                </p>
                <Link to="/settings/billing/subscribe" className="btn btn-primary">
                  {t('billing.subscribeToPlan')}
                </Link>
              </div>
            </div>
          :
            <div className="subheader-page-content scrollable">
              {activeSubscription ? (
                <ActiveSubscriptionCard sub={activeSubscription} company={companyData} />
              ) : (
                <div className="text-center mb-4">
                  <img
                    src={require('../../../../assets/images/icons/empty-folder.png')}
                    alt={t('billing.noActiveSubscription')}
                    width={150}
                  />
                  <p>
                    {t('billing.noActiveSubscriptionMessage')}
                  </p>
                  <Link to="/settings/billing/subscribe" className="btn btn-primary">
                    {t('billing.subscribeToPlan')}
                  </Link>
                </div>
              )}

              {/* Invoice History */}
              <Card>
                <CardBody>
                  <p className="text-muted small fw-semibold text-uppercase mb-3">{t('billing.invoiceHistory')}</p>
                  <Table hover responsive className="mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>{t('billing.invoice')}</th>
                        <th>{t('billing.date')}</th>
                        <th>{t('billing.amount')}</th>
                        <th>{t('billing.status')}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoiceHistories?.map(inv => (
                        <tr key={inv.id}>
                          <td className="fw-medium">{inv.id}</td>
                          <td className="text-muted">{new Date(inv.created_at).toLocaleString()}</td>
                          <td>{inv.amount} {inv.currency.toUpperCase()}</td>
                          <td>
                            {printPaymentStatus(inv.status)}
                          </td>
                          <td className="text-end">
                            <Button color="light" size="sm" outline>
                              <LuDownload size={14} />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </div>
        }
      </div>
    </SidebarLayout>
  );
}

export default BillingPage;
